import { useState } from 'react';
import { useQuery } from 'react-query';
import AuthService from '@services/AuthService';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { QUERY } from '@utils/constants';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

export default function SelectRoles({ selectedRoles, register }) {
  const [isServerRoles, setIsServerRoles] = useState(true);
  const [serverRoles, setServerRoles] = useState([]);

  useQuery([QUERY.ROLES, isServerRoles], AuthService.getRoles, {
    enabled: isServerRoles,
    onSuccess: onSuccessRoles,
    onError: onErrorRoles,
  });

  function onSuccessRoles(response) {
    setServerRoles(response.data);
    setIsServerRoles(false);
  }

  function onErrorRoles(response) {
    console.error(response.status, response.statusText);
    setIsServerRoles(false);
  }

  return (
    <Autocomplete
      multiple
      id='tags-outlined'
      size='small'
      options={serverRoles}
      disableCloseOnSelect
      getOptionLabel={(option) => option}
      renderOption={(props, option, { selected }) => {
        if (selected) {
          if (!selectedRoles.includes(option)) {
            selectedRoles.push(option);
          }
        }
        if (selectedRoles.includes(option) && !selected) {
          const index = selectedRoles.indexOf(option);
          selectedRoles.splice(index, 1);
        }

        const keyProp = props.key;
        delete props.key;
        return (
          <li key={keyProp} {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          {...register('Roles')}
          label='Roles'
          placeholder='Select roles'
        />
      )}
    />
  );
}
